import { alertVariants } from "@visiblethread/react-components";
import { showGlobalAlert } from "slices/app/appSlice";

export const showSuccessAlert = (dispatch, text) =>
  dispatch(
    showGlobalAlert({
      variant: alertVariants.success,
      text,
    })
  );

export const showErrorAlert = (dispatch, text) =>
  dispatch(
    showGlobalAlert({
      variant: alertVariants.danger,
      text,
    })
  );
